<div class="withPassword">
  @if (newPassword) {
    @if (errorMessage) {
      <div class="errorBlock">
        {{ errorMessage.message }}
      </div>
    }
    <mat-form-field class="withPassword-inputField">
      <input
        matInput
        class="password"
        [type]="hide() ? 'password' : 'text'"
        [placeholder]="'global.password' | translate"
        [(ngModel)]="password"
        name="password"
      />
      <button
        matSuffix
        mat-icon-button
        (click)="clickEventPassword($event)"
        [attr.aria-pressed]="hide()"
        [attr.aria-label]="'Hide password'"
      >
        <img
          [src]="
            hide()
              ? 'assets/icons/icon-eye-close.svg'
              : 'assets/icons/icon-eye-open.svg'
          "
          alt=""
        />
      </button>
    </mat-form-field>
    <mat-form-field class="withPassword-inputField">
      <input
        matInput
        class="password"
        [type]="hide() ? 'password' : 'text'"
        [placeholder]="'auth.withPassword.repeatPassword' | translate"
        [(ngModel)]="confirmPassword"
        name="password"
      />
      <button
        matSuffix
        mat-icon-button
        (click)="clickEventPassword($event)"
        [attr.aria-pressed]="hide()"
        [attr.aria-label]="'Hide password'"
      >
        <img
          [src]="
            hide()
              ? 'assets/icons/icon-eye-close.svg'
              : 'assets/icons/icon-eye-open.svg'
          "
          alt=""
        />
      </button>
    </mat-form-field>
    <mat-checkbox class="checkbox-text" [(ngModel)]="short_session">
      {{ "auth.withPassword.foreignComputer" | translate }}
    </mat-checkbox>
    <button
      class="btn btn-send"
      (click)="passwordResetComplete()"
      [disabled]="!password.length || (password !== confirmPassword)"
    >
      {{ "auth.withPassword.recover_btn" | translate }}
    </button>
  } @else if (!forgetPassword) {
    <div class="withPassword-header">
      {{ "auth.withPassword.title" | translate }}
    </div>
    @if (errorMessage) {
      <div class="errorBlock">
        {{ errorMessage.message }}
      </div>
    }
    <mat-form-field class="withPassword-inputField">
      <input
        matInput
        class="login"
        name="login"
        [placeholder]="'auth.withPassword.login_placeholder' | translate"
        [(ngModel)]="login"
      />
    </mat-form-field>
    <mat-form-field class="withPassword-inputField">
      <input
        matInput
        class="password"
        [type]="hide() ? 'password' : 'text'"
        [placeholder]="'global.password' | translate"
        [(ngModel)]="password"
        name="password"
      />
      <button
        matSuffix
        mat-icon-button
        (click)="clickEventPassword($event)"
        [attr.aria-pressed]="hide()"
        [attr.aria-label]="'Hide password'"
      >
        <img
          [src]="
            hide()
              ? 'assets/icons/icon-eye-close.svg'
              : 'assets/icons/icon-eye-open.svg'
          "
          alt=""
        />
      </button>
    </mat-form-field>
    <mat-checkbox class="checkbox-text" [(ngModel)]="short_session">
      {{ "auth.withPassword.foreignComputer" | translate }}
    </mat-checkbox>
    <button
      class="btn btn-send"
      (click)="loginWithPassword()"
      [disabled]="!login || !password"
    >
      {{ "auth.withPassword.enter" | translate }}
    </button>
    <button class="btn btn-forgetPassword" (click)="forgetPasswordFunc()">
      {{ "auth.withPassword.forgetPassword" | translate }}
    </button>
  } @else {
    <div class="withPassword-header">
      {{ "auth.withPassword.recover_btn" | translate }}
    </div>
    @if (errorMessage) {
      <div class="errorBlock">
        {{ errorMessage.message }}
      </div>
    }
    <mat-form-field class="withPassword-inputField">
      <input
        matInput
        class="login"
        name="login"
        [placeholder]="'auth.withPassword.login_placeholder' | translate"
        [(ngModel)]="login"
      />
    </mat-form-field>
    <button class="btn btn-send" (click)="routeToConfirm()" [disabled]="!login">
      {{ "auth.withPassword.recover_btn" | translate }}
    </button>
  }
</div>
